import { render, staticRenderFns } from "./MyChilds.vue?vue&type=template&id=378b36cf&lang=pug&"
import script from "./MyChilds.vue?vue&type=script&lang=js&"
export * from "./MyChilds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports